import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['dropDown']

  connect() {
    this.url = new URL(window.location)

    this.dropDownTargets.forEach(item => {
      item.addEventListener('blur', (event) => {
        item.classList.remove('h-open')
      });
    })
  }

  biographyFilter(event) {
    this.url.searchParams.set('biography', event.currentTarget.value)
    window.location.href = this.url.toString()
  }

  toggleDropdown(event) {
    const classList = event.currentTarget.classList
    if (classList.contains('h-open')){
      event.currentTarget.classList.remove('h-open')
    } else {
      event.currentTarget.classList.add('h-open')
    }
  }

  usernameFilter(event) {
    this.url.searchParams.set('username', event.currentTarget.value)
    window.location.href = this.url.toString()
  }

  followerLowFilter(event) {
    this.url.searchParams.set('followers_count_low_limit', event.currentTarget.value)
    window.location.href = this.url.toString()
  }

  followerHighFilter(event) {
    this.url.searchParams.set('followers_count_high_limit', event.currentTarget.value)
    window.location.href = this.url.toString()
  }

  accountTypeFilter(event) {
    this.url.searchParams.set('account_type', event.currentTarget.value)
    window.location.href = this.url.toString()
  }
}